import { Component, OnInit, Input, ViewChild, ViewChildren, QueryList, EventEmitter, Output } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { ArchivosService } from 'src/app/servicios/archivos.service';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-expandir-imagen',
  templateUrl: './expandir-imagen.component.html',
  styleUrls: ['./expandir-imagen.component.scss'],
})
export class ExpandirImagenComponent implements OnInit {

  @Input() indice = 0
  @Input() set mIndice(val){
    this.indice = val
    if (this.OtrasImagenes.length > 0) {
      this.Imagen = this.OtrasImagenes[this.indice]
    }
  }
  @Output() newIndice = new EventEmitter();
  @Input() Loop: boolean = false;
  Favoritos = []
  @Input() Imagen: any;
  UserID = ""
  @ViewChild("Slides") Slides: IonSlides;
  Mobile = "none";
  Desk = ""
  @Input() close = true;
  @Input() auto = false;

  @Input() OtrasImagenes = [];

  idv = ""

  @Input() set Mov(val) {
    if (this.Imagen.Tipo == "Video" && val > 0) {
      this.auto = false;
      let video = document.getElementById("video" + this.idv)
      video["pause"]()
    }
  }

  constructor(public modal: ModalController, private archivos: ArchivosService,
    private conexion: ConexionService, private utilidades: UtilidadesService) { }


  ops = {
    zoom: true
  };


  ionViewDidEnter() {
    this.Slides.update();
  }

  async zoom(zoomIn: boolean) {
    const slider = await this.Slides.getSwiper();
    const zoom = slider.zoom;
    zoomIn ? zoom.in() : zoom.out();
  }

  Siguiente() {
    if (this.indice < this.OtrasImagenes.length - 1) {
      this.indice += 1
    } else {
      if (this.Loop) {
        this.indice = 0
      }
    }
    this.Imagen = this.OtrasImagenes[this.indice]

    this.newIndice.emit(this.indice)
  }

  Anterior() {
    if (this.indice > 0) {
      this.indice -= 1
    } else {
      if (this.Loop) {
        this.indice = this.OtrasImagenes.length - 1
      }
    }
    this.Imagen = this.OtrasImagenes[this.indice]

    this.newIndice.emit(this.indice)
  }

  ngOnInit() {
    this.utilidades.Depuracion(this.Imagen, "console", "")
    if (this.OtrasImagenes.length > 0) {
      this.Imagen = this.OtrasImagenes[this.indice]
    }
    this.idv = String(parseInt(String(Math.random() * 100)))
    this.UserID = atob(localStorage.getItem(btoa("Id")))
    this.getFavoritos()
    setTimeout(() => {
      this.Slides.lockSwipes(true)
    }, 800);
  }

  // Compartir(texto:string, titulo:string, link:string, file?:string){
  //   // const url = this.link
  //   const text = texto+'\n'
  //   this.socialSharing.share(text, titulo, file, link)
  // }

  getFavoritos() {
    // this.utilidades.Loading("Cargando favoritos")
    this.conexion.getFavoritos(this.UserID).subscribe((resp) => {
      // this.utilidades.CerrarLoading()
      if (resp.Respuesta == "Exito") {
        this.Favoritos = resp.Datos
        this.EsFavorito()
      }
    }, (err) => {
      // this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      this.utilidades.ValidarUser(err)
    })
  }


  EsFavorito() {
    for (let i of this.Favoritos) {
      if ((i.TipoElemento == "Horario" || i.TipoElemento == "Media" || i.TipoElemento == "Foto" || i.TipoElemento == "Video" || i.TipoElemento == "Calendario")
        && String(i.IdElemento) == (this.Imagen.IdFoto || this.Imagen.IdArchivo)) {
        this.Imagen.Favorito = 1
        return true
      }
    }
    this.Imagen.Favorito = 0
    return false
  }

  Compartir() {
    this.archivos.CompartirArchivo("¡Te comparto esta foto!", "Espero que te guste",
      this.Imagen.IdFoto || this.Imagen.IdArchivo, this.Imagen.Nombre, document)
  }


  Imprimir() {

    let vent = window.open('', '', 'height=800, width=800');
    vent.document.write(document.getElementById("img").innerHTML)

    vent.document.close()
    setTimeout(() => {
      vent.print()
    }, 2000);

  }


  Favorito(nf) {
    // this.utilidades.Loading("Cargando actividad")
    this.conexion.Favorito(atob(localStorage.getItem(btoa("Id"))),
      this.Imagen.IdFoto || this.Imagen.IdArchivo, this.Imagen.Tipo, this.Imagen.Titulo).subscribe((resp) => {
        this.utilidades.CerrarLoading()
        this.Imagen.Favorito = nf
        if (nf == 1) {
          this.utilidades.Toast(this.Imagen.Tipo + " guardado(a) en favoritos", 3000, "star")
        } else {
          this.utilidades.Toast(this.Imagen.Tipo + " eliminado(a) de favoritos", 3000, "star-outline")
        }
        this.utilidades.nexSubExpandirImagen(true)
      }, (err) => {
        this.utilidades.CerrarLoading()
        this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
        this.utilidades.ValidarUser(err)
      })
  }
}
